import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { saveGustoAccessToken } from 'api/hris-integration';
import { getReport } from 'api/reports';
import { Report } from 'graphql-api';
import { IMPORTING_HRIS_DATA_STEP } from 'constants/report-steps';
import { navigateAndStoreStep } from 'utils/navigation';
import { reportCurrentStepPath } from 'utils/path';
import ProcessingModal from 'components/processing-modal';

function GustoOauthCallback(): JSX.Element {
  const [searchParams] = useSearchParams();
  const effectCalled = useRef<Boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (effectCalled.current === true) return;
    effectCalled.current = true;

    void (async () => {
      const reportId = searchParams.get('reportId') ?? '';
      const report = (await getReport(reportId)) as Report;
      if (report === undefined || report == null) {
        return;
      }
      const result = await saveGustoAccessToken(reportId, searchParams.get('code') ?? '');
      if (result) {
        await navigateAndStoreStep(report, IMPORTING_HRIS_DATA_STEP, navigate);
      } else {
        alert('Error while integrating Gusto...');
        navigate(reportCurrentStepPath(report));
      }
    })();
  });

  return <ProcessingModal header="Setting up Gusto Connection..." />;
}

export default GustoOauthCallback;
